
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { dspApi } from "../../repositories/dsp";
import { DSPData } from "../../components/types/types";
import { ArrowLeftIcon, Loader } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { formatDSPName } from "../../utils/formatDSP";

const UserDsps: React.FC = () => {
  const [dspList, setDspList] = useState<DSPData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const fetchDSPs = async () => {
    try {
      setLoading(true);
      if (!id) {
        throw new Error("ID is required to fetch DSPs");
      }
      const response = await dspApi.getDspById(id);
      setDspList(response.data.data);
    } catch (error: any) {
      if (error.response?.status === 404) {
        setDspList([]);
      } else {
        Swal.fire(
          "Error",
          error?.response?.data?.message ||
            error.message ||
            "An unknown error occurred",
          "error"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDSPs();
  }, []);

  return (
    <div className="min-h-screen p-6 bg-gray-50">
    <div className="flex items-center justify-between mb-6">
      <button
          onClick={() => navigate("/dashboard")}
          className="flex items-center mb-4 text-gray-600 hover:text-gray-800"
        >
          <ArrowLeftIcon className="w-5 h-5 mr-2" /> Back
        </button>
        <h1 className="text-2xl font-bold text-gray-700">DSP Management</h1>
    </div>


      {loading ? (
        <div className="flex items-center justify-center h-64">
          <Loader size={40} className="text-gray-600 animate-spin" />
        </div>
      ) : dspList.length === 0 ? (
        <div className="flex items-center justify-center h-64 text-gray-500">
          No DSP accounts found.
        </div>
      ) : (
        <table className="w-full bg-white border rounded-lg shadow-md">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 text-left border">ID</th>
              <th className="p-3 text-left border">Name</th>
              <th className="p-3 text-left border">Email</th>
              <th className="p-3 text-left border">Paswword</th>
              <th className="p-3 text-left border">Type</th>
            </tr>
          </thead>
          <tbody>
            {dspList.map((dsp, index) => (
              <tr
                key={dsp.id}
                className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
              >
                <td className="p-3 border">{dsp.id}</td>
                <td className="p-3 border">{dsp.name}</td>
                <td className="p-3 border">{dsp.email}</td>
                <td className="p-3 border">{dsp.password}</td>
                <td className="p-3 border">{formatDSPName(dsp.type)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UserDsps;
